import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container-luxury max-w-3xl">
          <h1 className="font-display text-3xl md:text-4xl tracking-wider text-foreground mb-16 text-center">
            Privacy Policy
          </h1>

          <div className="space-y-10 font-body text-foreground/70 text-sm leading-[1.9]">
            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">1. Introduction</h2>
              <p>1.1 Arzani Group Worldwide ("Arzani", "we", "our", or "us") respects your privacy and is committed to protecting your personal data.</p>
              <p className="mt-2">1.2 This Privacy Policy explains how we collect, use, process, and protect your personal information when you use our services or contact us.</p>
              <p className="mt-2">1.3 By using our services or submitting your information, you agree to this Privacy Policy.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">2. Information We Collect</h2>
              <p>2.1 We may collect the following personal information:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Destination preferences</li>
                <li>Booking details</li>
                <li>Payment-related information (processed via secure third-party providers)</li>
                <li>Identification details where required by third-party providers (for example, yacht charter regulations)</li>
              </ul>
              <p className="mt-2">2.2 We may also collect information voluntarily provided via WhatsApp, email, website forms, or other communication channels.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">3. How We Use Your Information</h2>
              <p>3.1 We use your personal information to:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                <li>Arrange and coordinate requested services</li>
                <li>Communicate regarding bookings and inquiries</li>
                <li>Process payments</li>
                <li>Provide customer support</li>
                <li>Improve our services</li>
                <li>Comply with legal obligations</li>
              </ul>
              <p className="mt-2">3.2 We only collect personal information that is necessary for providing our concierge services.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">4. Sharing of Information</h2>
              <p>4.1 As Arzani operates as an intermediary, personal data may be shared with relevant third-party service providers solely for the purpose of fulfilling your booking.</p>
              <p className="mt-2">4.2 We do not sell, rent, or trade personal data to third parties.</p>
              <p className="mt-2">4.3 Payment information is processed securely by authorized payment providers and is not stored by Arzani unless legally required.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">5. Data Security</h2>
              <p>5.1 We implement reasonable technical and organizational measures to protect personal data from unauthorized access, misuse, loss, or disclosure.</p>
              <p className="mt-2">5.2 However, no internet-based service can be completely secure, and we cannot guarantee absolute security.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">6. Data Retention</h2>
              <p>6.1 Personal data is retained only as long as necessary to fulfill the purposes outlined in this policy or to comply with applicable legal obligations.</p>
              <p className="mt-2">6.2 Clients may request deletion of their personal data unless legal or contractual obligations require continued retention.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">7. Confidentiality</h2>
              <p>7.1 All client communications are handled with discretion.</p>
              <p className="mt-2">7.2 Arzani is committed to maintaining confidentiality in all client relationships.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">8. Your Rights</h2>
              <p>8.1 You may request access to, correction of, or deletion of your personal data.</p>
              <p className="mt-2">8.2 You may withdraw consent to data processing where applicable.</p>
              <p className="mt-2">8.3 Requests can be submitted via email to{" "}
                <a href="mailto:info@arzanigroupworldwide.com" className="text-foreground/90 underline underline-offset-4 hover:text-foreground transition-colors duration-500">
                  info@arzanigroupworldwide.com
                </a>.
              </p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">9. Third-Party Platforms</h2>
              <p>9.1 When communicating via platforms such as WhatsApp, Instagram, or other external services, your data may also be subject to the privacy policies of those platforms.</p>
              <p className="mt-2">9.2 Arzani is not responsible for the privacy practices of third-party platforms.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">10. Changes to This Policy</h2>
              <p>10.1 Arzani reserves the right to update this Privacy Policy when necessary.</p>
              <p className="mt-2">10.2 The most recent version will always be available on our website.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
